import { useContext } from "react";

import AuthContext, { IAuthContext } from "./AuthContext";

export const useAuthContext = (): IAuthContext => {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error("useAuthContext must be called with a AuthContextProvider");
  }

  return ctx;
};
